import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-layout',
  template: `
    <div id="app-container-2">
      <div id="app-content">
        <router-outlet></router-outlet>
      </div>
      <app-bottom-nav class="app-bottom-nav"></app-bottom-nav>
    </div>
  `,
  styles: [`
    #app-container-2 {
      height: 100%;
      width: 100%;
      overflow-x: hidden;
      overflow-y: hidden;
    }
    #app-content{
      position: absolute;
      top: 0px;
      right: 0px;
      left: 0px;
      height: 100%;
    }
    .app-bottom-nav {
      position: absolute;
      right: 0px;
      bottom: 0px;
      left: 0px;
      height: 4rem;
      z-index:1000;
    }
    @media screen and (max-height: 460px) {
      .app-bottom-nav {
        display: none;
      }
    }
  `
  ]
})
export class BottomLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
